// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__293bq","noInteraction":"EventWrapper_noInteraction__2MYgE","pointerPassthrough":"EventWrapper_pointerPassthrough__VEmxJ"};